import dataLayerPush from './DataLayer';

export default function cart(dataJsonString: string, totalPrice: number) {
  const data = JSON.parse(dataJsonString);
  return {
    data,
    sendCartView() {
      dataLayerPush({
        event: 'view_cart',
        ecommerce: {
          send_to: 'GA4',
          currency: 'EUR',
          value: totalPrice,
          items: this.data,
        },
      });
    },
  };
}
